<script setup>
import {
    toRefs, defineProps, inject
    // defineEmits
} from 'vue';
// import Swal from "sweetalert2";
// import i18n from "@/i18n"
// import { useRoute } from "vue-router";
// const route = useRoute()
import { getLangValue } from "@/utils/common"; //获取后端语言
const currentTabLang = inject('currentTabLang') //切换语言
const props = defineProps({
    indicatorList: {
        type: Array,
        default: () => {
            return []
        }
    },
    isCheckForm: {
        type: Boolean,
        default: false
    },
})

// const emits = defineEmits(["onAddgroupindicator", "onDeleteGroupindicator", "onDeleteGroup", "showInfo"])

const { indicatorList } = toRefs(props)



// const deleteGroupindicator = (g_i) => {
//     Swal.fire({
//         title: i18n.global.t("base.delete_alert_title"),
//         text: i18n.global.t("base.delete_alert_info"),
//         icon: "warning",
//         showCancelButton: true,
//         cancelButtonColor: "#f46a6a",
//         confirmButtonColor: "#34c38f",
//         confirmButtonText: i18n.global.t("base.done"),
//         cancelButtonText: i18n.global.t("base.cancel"),
//     }).then(async (result) => {
//         if (result.isConfirmed) {
//             emits("onDeleteGroupindicator", g_i)
//         }
//     });

// }

// const addGroupindicator = () => {
//     emits("onAddgroupindicator")
// }

// const chnagegroupindicatorName =(i,g_i)=> {
//     console.log(i, g_i);
//     const {indicatorList} = groupInfoList.value[i];
//     const {name} = indicatorList[g_i];
//     console.log(name);
//     // 筛选名称看是否重复
//     let arr =indicatorList.filter(item=> item.name === name)
//     console.log(arr);
//     if(arr.length> 1){
//         emits("showInfo")
//     }
// }

const mouseOver = (item) => {
    item.showReference = true;
}
const mouseLeave = (event, item) => {
    // 获取鼠标离开时的元素
    let relatedTarget = event.relatedTarget;
    if (relatedTarget && relatedTarget.className == "popover-arrow") {
        return;
    }
    item.showReference = false;
}
</script>
<template>
    <div class="group-content">
        <div class="group row">
            <div class="group-index" v-if="indicatorList.length">
                <div class="group-index-title">
                    <div style="max-width: 120px;">
                        <!-- <span class="text-danger">*</span> -->
                        {{ getLangValue('hscode.indicatorName') }}
                    </div>
                    <div style="max-width: 100px;">{{ getLangValue('attribute.value') }}</div>
                    <div style="max-width: 100px;">{{ getLangValue('attribute.unit') }}</div>
                    <!-- <div>{{ getLangValue('attribute.reference') }}</div> -->
                    <div>
                        <!-- <span class="text-danger">*</span> -->
                        {{ getLangValue('product-template.testingOrganization') }}
                    </div>
                    <div>
                        <!-- <span class="text-danger">*</span> -->
                        {{ getLangValue('product-template.testingOrganizationQualification') }}
                    </div>
                    <!-- <div>*{{ getLangValue('product-template.report') }}</div> -->
                    <div>{{ getLangValue('product-template.testDate') }}</div>
                    <div>{{ getLangValue('product-template.testinginstitutions') }}</div>
                    <div>{{ getLangValue('product-template.testinginstitutions1') }}</div>
                    <!-- <div style="max-width: 100px;">{{ getLangValue('product-template.remark') }}</div> 2024-09-20去掉备注信息 -->
                    <!-- <div style="flex:unset;width: 48px;"></div> -->
                </div>
                <div class="group-index-input" v-for="(groupindicator, groupindicatorindicator_index) in indicatorList"
                    :key="`groupindicator--${groupindicatorindicator_index}`">
                    <div style="max-width: 120px;">
                        <input v-model="groupindicator.name" type="text" class="form-control" :class="[
                            (isCheckForm && !groupindicator.name) && 'is-invalid',
                        ]" required v-if="groupindicator.isNewAdd" />
                        <span v-else>{{ currentTabLang == 1 ? groupindicator.name : groupindicator.name_en }}</span>
                        <i :id="groupindicator.id" class="ri-question-line" @mouseover="mouseOver(groupindicator)"
                            @mouseleave="mouseLeave($event, groupindicator)"></i>
                        <b-popover :target="groupindicator.id" v-model:show="groupindicator.showReference"
                            triggers="">
                            <div :ref="`reference${groupindicator.id}`" style="min-width: 200px;"
                                @mouseleave="groupindicator.showReference = false">
                                <b-form-textarea v-if="currentTabLang ==1" v-model="groupindicator.reference" disabled
                                    :placeholder="getLangValue('attribute.reference')" rows="3"></b-form-textarea>
                                <b-form-textarea v-if="currentTabLang ==2" v-model="groupindicator.reference_en" disabled
                                    :placeholder="getLangValue('attribute.reference')" rows="3"></b-form-textarea>
                            </div>
                        </b-popover>
                    </div>
                    <div style="max-width: 100px;">
                        <!-- <input v-model="groupindicator.value" type="text" class="form-control" required /> -->
                        <!-- {{ groupindicator.value }} -->
                        <input disabled :class="[(isCheckForm && !groupindicator.value) && 'is-invalid']"
                            v-model="groupindicator.value" type="text" class="form-control" required />
                    </div>
                    <div style="max-width: 100px;">
                        <input v-model="groupindicator.unit" type="text" class="form-control" required
                            v-if="groupindicator.isNewAdd" />
                        <span v-else>{{ currentTabLang == 1 ? groupindicator.unit : groupindicator.unit_en }}</span>
                    </div>
                    <!-- <div style="word-break: break-all;">
                        <textarea style="height: 37.5px;" v-model="groupindicator.reference" class="form-control"
                            required v-if="groupindicator.isNewAdd" />
                        <span v-else>{{ groupindicator.reference }}</span>
                    </div> -->
                    <div class="d-flex align-items-center">
                        <input disabled :class="[(isCheckForm && !groupindicator.testing_institution) && 'is-invalid']"
                            v-model="groupindicator.testing_institution" type="text" class="form-control" required />
                    </div>
                    <!-- 新增信息 -->
                    <div class="d-flex align-items-center">
                        <input disabled :class="[(isCheckForm && !groupindicator.certification_date) && 'is-invalid']"
                            v-model="groupindicator.certification_date" type="text" class="form-control" required />

                    </div>
                    <div class="d-flex align-items-center">
                        <input disabled
                            :class="[(isCheckForm && !groupindicator.validity_period_of_certification) && 'is-invalid']"
                            v-model="groupindicator.validity_period_of_certification" type="text" class="form-control"
                            required />
                    </div>
                    <div class="d-flex align-items-center">
                        <input disabled :class="[(isCheckForm && !groupindicator.certification_body) && 'is-invalid']"
                            v-model="groupindicator.certification_body" type="text" class="form-control" required />
                    </div>
                    <!-- 新增信息 -->
                    <div class="d-flex align-items-center">
                        <input disabled
                            :class="[(isCheckForm && !groupindicator.qualification_of_testing_institution) && 'is-invalid']"
                            v-model="groupindicator.qualification_of_testing_institution" type="text"
                            class="form-control" required />
                    </div>
                    <!-- <div class="d-flex align-items-center">
                        <el-select disabled 
                            :class="[(isCheckForm && !groupindicator.has_report) && 'is-invalid']"
                            v-model="groupindicator.has_report" size="large" placeholder="   "
                            style="width: 60px; height: 40px;" clearable>
                            <el-option label="是" value="是" />
                            <el-option label="否" value="否" />
                        </el-select>
                    </div> -->
                    <!-- <div class="d-flex align-items-center" style="max-width: 100px;">
                        <input disabled v-model="groupindicator.remark" type="text" class="form-control" required />
                    </div> 2024-09-20去掉备注信息 -->

                </div>

            </div>
            <!-- <div style="text-align: center; margin-top: 10px;">
                <button type="button" class="btn btn-primary me-3" style="background-color: #2C404C;"
                    @click="addGroupindicator">{{ getLangValue("hscode.addIndicator1")
                    }}</button>
            </div> -->
        </div>
    </div>
</template>
<style scoped lang="scss">
.group-content {
    .group {
        margin: 10px 0;

        .is-invalid {
            border: 1px solid #f06548;
            border-radius: 4px;
        }

        .group-index {

            .group-index-title,
            .group-index-input {
                display: flex;
                align-items: center;

                div {
                    flex: 1;
                    margin: 10px;
                }
            }
        }
    }

}
</style>